type BodyOverflowValue = "hidden" | "auto" | undefined;

export function setBodyOverflow(value: BodyOverflowValue): void {
  const body: HTMLElement = document.body;
  body.style.overflow = value;
}

export function getElementByIdPromise(
  value = "",
  delay = 500
): Promise<HTMLElement> {
  if (!value) return null;

  let timer;

  const target = new Promise<HTMLElement>((resolve, _) => {
    const element = document.getElementById(value);
    if (element) return resolve(element);

    timer = setInterval(() => {
      const element = document.getElementById(value);
      if (element) return resolve(element);
    }, delay);
  }).finally(() => timer && clearInterval(timer));

  return target;
}
